import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';

@Component({
  selector: 'modal-add-question',
  templateUrl: './modal-add-question.component.html',
  styleUrls: ['./modal-add-question.component.css'],
})
export class ModalAddQuestionComponent {

  @ViewChild('modal') private modal: any; // tslint:disable-line:no-any
  @Output() private confirm: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  @Output() private cancel: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  public questions: Array<Question> = [];
  public filteredQuestions: Array<Question>;
  public fieldsToSearch: Array<Array<string>> = [];
  private nodeData: Node;

  public show(): ModalAddQuestionComponent {
    this.modal.show();
    return this;
  }

  public hide(): ModalAddQuestionComponent {
    this.modal.hide();
    return this;
  }

  public setQuestions(questions: Array<Question>): ModalAddQuestionComponent {
    this.questions = questions;
    this.prepareFieldsToSearch();
    return this;
  }

  public setNodeData(nodeData: Node): ModalAddQuestionComponent {
    this.nodeData = nodeData;
    return this;
  }

  public doConfirm(selectedQuestion: Question): void {
    this.hide();
    this.confirm.emit(selectedQuestion);
  }

  public doCancel(): void {
    this.hide();
    this.cancel.emit(null);
  }

  public filterQuestions(eventQuestions: Array<Question>): void {
    this.filteredQuestions = eventQuestions;
  }

  private prepareFieldsToSearch(): void {
    this.questions.forEach((question) => {
      this.fieldsToSearch.push([
        question.title.de.toLowerCase(),
      ]);
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-add-question/modal-add-question.component.ts